var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 151.844,
    height: 151.844,
    rx: 75.922,
    fill: "#EFF8F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.698 84.234H100.758V81.9261H103.698C104.66 81.9261 105.435 81.3261 105.435 80.6106V51.6234C105.409 50.908 104.66 50.3079 103.698 50.3079H54.8438V48H103.698C106.13 48 108.108 49.6386 108.108 51.6234V80.6106C108.081 82.6185 106.13 84.234 103.698 84.234Z",
    fill: "#09081A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9856 84.234H48.4097C45.9777 84.234 44 82.6185 44 80.6106V51.6234C44 49.6386 45.9777 48 48.4097 48H51.9375V50.3079H48.4097C47.4476 50.3079 46.6726 50.908 46.6726 51.6234V80.6106C46.6726 81.3491 47.4476 81.9261 48.4097 81.9261H97.9856V84.234Z",
    fill: "#09081A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1569 49.1562H81.4844V83.0824H84.1569V49.1562Z",
    fill: "#09081A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6491 49.1562H67.9766V83.0824H70.6491V49.1562Z",
    fill: "#09081A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.772 56.4922H82.7988V58.8006H106.772V56.4922Z",
    fill: "#09081A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3472 56.4922H45.3477V58.8006H69.3472V56.4922Z",
    fill: "#09081A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.772 64.9688H82.7988V67.2771H106.772V64.9688Z",
    fill: "#09081A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3472 64.9688H45.3477V67.2771H69.3472V64.9688Z",
    fill: "#09081A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.772 73.4609H82.7988V75.7693H106.772V73.4609Z",
    fill: "#09081A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3472 73.4609H45.3477V75.7693H69.3472V73.4609Z",
    fill: "#09081A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6294 63.9609H51.0684V68.2776H63.6294V63.9609Z",
    fill: "#05D383"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5985 69.4375H51.0375C50.2891 69.4375 49.7012 68.9297 49.7012 68.2833V63.9667C49.7012 63.3203 50.2891 62.8125 51.0375 62.8125H63.5985C64.3468 62.8125 64.9347 63.3203 64.9347 63.9667V68.2833C64.9347 68.9066 64.3468 69.4375 63.5985 69.4375ZM52.4005 67.1291H62.2889V65.1209H52.4005V67.1291Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.059 63.9609H88.498V68.2776H101.059V63.9609Z",
    fill: "#05D383"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.063 69.4375H88.5023C87.754 69.4375 87.166 68.9297 87.166 68.2833V63.9667C87.166 63.3203 87.754 62.8125 88.5023 62.8125H101.063C101.812 62.8125 102.4 63.3203 102.4 63.9667V68.2833C102.4 68.9066 101.785 69.4375 101.063 69.4375ZM89.8386 67.1291H99.727V65.1209H89.8386V67.1291Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1022 103.395L59.0332 101.585C61.2247 100.877 63.0688 99.1066 62.1066 97.2184C61.8661 96.7464 61.4385 96.294 60.9842 95.8219C60.5031 95.3105 60.022 94.7991 59.6479 94.1697C57.8573 90.9833 62.1066 89.2131 64.1378 88.3477L65.4741 90.0589C62.3204 91.3964 61.4652 92.2421 62.1334 93.4223C62.3739 93.855 62.7748 94.268 63.1757 94.7008C63.7102 95.2515 64.2447 95.8219 64.5921 96.5497C66.1155 99.5787 63.4162 102.332 60.1022 103.395Z",
    fill: "#05D383"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9753 103.395L72.9062 101.585C75.0977 100.877 76.9418 99.1066 75.9797 97.2184C75.7392 96.7464 75.3115 96.294 74.8572 95.8219C74.3762 95.3105 73.8951 94.7991 73.5209 94.1697C71.7303 90.9833 75.9797 89.2131 78.0108 88.3477L79.3471 90.0589C76.1935 91.3964 75.3383 92.2421 76.0064 93.4223C76.2469 93.855 76.6478 94.268 77.0487 94.7008C77.5832 95.2515 78.1177 95.8219 78.4652 96.5497C79.9885 99.5787 77.2892 102.332 73.9753 103.395Z",
    fill: "#05D383"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8268 103.395L86.7578 101.585C88.9493 100.877 90.7934 99.1066 89.8313 97.2184C89.5907 96.7464 89.1631 96.294 88.7088 95.8219C88.2277 95.3105 87.7467 94.7991 87.3725 94.1697C85.5819 90.9833 89.8313 89.2131 91.8624 88.3477L93.1987 90.0589C90.0451 91.3964 89.1898 92.2421 89.858 93.4223C90.0985 93.855 90.4994 94.268 90.9003 94.7008C91.4348 95.2515 91.9693 95.8219 92.3167 96.5497C93.8668 99.5787 91.1408 102.332 87.8268 103.395Z",
    fill: "#05D383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcServices);
export default __webpack_public_path__ + "static/media/AC Services.a9446c1b.svg";
export { ForwardRef as ReactComponent };